
import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import ShipToAddress from '@/components/orders/new-order/ShipToAddress.vue';
import { SapCustomerPartner } from '@/api/model/sap-customer-partner';
import { SalesOrderAll as SalesOrder } from '@/logic/orders/SalesOrderAll';

@Component({
  components: { ShipToAddress },
  computed: {
    ...mapState('order', ['cart', 'shipToPartners', 'loadingShipToPartners']),
  },
})
export default class ShipToField extends Vue {
  cart!: SalesOrder;

  shipToPartners!: SapCustomerPartner[];

  loadingShipToPartners!: boolean;

  get shipToParty(): string | null | undefined {
    return this.cart.ShipToParty;
  }

  get partners(): SapCustomerPartner[] {
    const partners = this.shipToPartners;
    if (
      !this.cart.ShipToParty &&
      partners.length === 1 &&
      partners[0].CustomerNr
    ) {
      this.setShipToParty(partners[0].CustomerNr);
    }
    return partners;
  }

  mounted() {
    this.$store.dispatch('order/fetchShipToPartners');
  }

  setShipToParty(customerNr: string) {
    this.$store.commit('order/setCartShipToParty', {
      CustomerNr: customerNr,
    });
  }
}
